import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4j1osx4h0b: FaireBrandEntity = {
  token: "b_4j1osx4h0b",
  type: "brand",
  name: "Shaman's Dawn",
  avatarUrl:
    "https://cdn.faire.com/fastly/d371e0daa507137124736184866c12e9d365941468464bdb06e3e5a63e4baf8f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/7fc6f1623266b344dfad15f1302eec22819587d9af231cd7739a5d69b5238481.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d371e0daa507137124736184866c12e9d365941468464bdb06e3e5a63e4baf8f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7fc6f1623266b344dfad15f1302eec22819587d9af231cd7739a5d69b5238481.jpeg",
  location: "Saugerties, NY, USA",
  minimumOrderDollars: 208,
  rating: 5,
  reviewCount: 34,
  isTopShop: true,
  isInsider: true,
  description:
    "Shaman's Dawn\n\nShaman's Dawn is a small business owned by Adam Kane and Alvaro Romao. We are dedicated to being of service to our community- the people, land, and spirits. The products that we create are all handmade in small batches using high quality ingredients with a focus on sustainability, environmental impact, and healthy living.\n\nShamanically Charged\n\nOne of the primary things that sets Shaman's Dawn handmade items and supplies apart from other sources is that they are all blessed during shamanic ceremony. \n\nWhen a batch of products is complete we infuse it with healing energy, prayer, and intention through shamanic ceremony. This is done to \"wake up\" the nature spirits of the botanicals and to ask the healing spirits of creation to bless the items for their intended purpose.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:07.808Z",
    importedBy: "entity-db-cli",
  },
};
